import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import moment from 'moment';
import {
	HttpStatusCodes,
	ClientRequestStatus,
	collaborationFilterTypeEnum,
	ParentAccepted,
	ParentDraft,
	ParentReceived,
	ParentPendingResponse
} from '../../util/uiconstants';
import {isApiResponseOk} from '../../util/utils';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function clientRequestReducer(state = initialState.clientRequests, action) {
	switch (action.type) {
		case types.GET_CLIENT_REQUESTS: {
			state = {...state, updateRequestList: false};
			if (isApiResponseOk(action)) {
				let objectCopy = _.cloneDeep(state);
				if (action?.isAdvancedBulkOperations) {
					objectCopy.bulkRequestState = {...action.response};
				} else {
					objectCopy = {
						...objectCopy,
						...action.response,
						requestsReadModel: action?.response?.requestsReadModel?.map((x) => {
							return {...x, checked: false};
						})
					};
				}
				return objectCopy;
			}
			return state;
		}
		case types.UPDATE_CLIENT_REQUEST: {
			let newState = _.cloneDeep(state);
			let req = newState.requestsReadModel.find(
				(request) => request.clientRequestID == action.data.response.clientRequestID
			);

			if (req) {
				if (action.data.response.attachmentCount >= 0) req.attachmentCount = action.data.response.attachmentCount;
			}
			return newState;
		}

		case types.CLEAR_BULK_CLIENT_REQUESTS_FROM_STORE:
			return {...state, bulkRequestState: {}};

		case types.ASSOCIATE_CLIENT_REQUEST_TAG: {
			if (action.responseObj?.status === HttpStatusCodes.Ok) {
				let requests = {
					...state,
					requestsReadModel: [...state.requestsReadModel]
				};

				for (let i = 0; i < action.data?.entitiesUIds?.length; i++) {
					const requestIndex = requests.requestsReadModel.findIndex(
						(r) => r.clientRequestID == action.data?.entitiesUIds[i]
					);

					if (requestIndex >= 0) {
						let request = {...requests.requestsReadModel[requestIndex]};
						let tags = [...request.tagsList];

						tags.push({
							clientRequestID: request.clientRequestID,
							engagementTagID: action.data.tagId,
							engagementTagName: action.tagData.tagName,
							colorCode: action.tagData.tagColor
						});

						request.tagsList = tags;

						const readModel = requests.requestsReadModel.map((item, index) => {
							if (index === requestIndex) {
								return {
									...item,
									...request
								};
							}
							return item;
						});

						requests = {
							...state,
							requestsReadModel: [...readModel],
							silentRefresh: true
						};
					}
				}
				return requests;
			}

			return state;
		}

		case types.UNASSOCIATE_CLIENT_REQUEST_TAG: {
			if (action.responseObj?.status === HttpStatusCodes.NoContent) {
				let requests = {
					...state,
					requestsReadModel: [...state.requestsReadModel]
				};

				for (let i = 0; i < action.data?.entitiesUIds?.length; i++) {
					const requestIndex = requests.requestsReadModel.findIndex(
						(r) => r.clientRequestID == action.data?.entitiesUIds[i]
					);

					if (requestIndex >= 0) {
						const tagIndex = requests.requestsReadModel[requestIndex].tagsList.findIndex(
							(t) => t.engagementTagID == action.data.tagId
						);
						let request = {...requests.requestsReadModel[requestIndex]};

						if (tagIndex >= 0) {
							request = {
								...request,
								tagsList: [...request.tagsList.slice(0, tagIndex), ...request.tagsList.slice(tagIndex + 1)]
							};

							const readModel = requests.requestsReadModel.map((item, index) => {
								if (index === requestIndex) {
									return {
										...item,
										...request
									};
								}
								return item;
							});

							requests = {
								...state,
								requestsReadModel: [...readModel],
								silentRefresh: true
							};
						}
					}
				}
				return requests;
			}

			return state;
		}
		case types.CREATE_CLIENT_REQUEST_COMMENT: {
			if (action.responseObj?.status === HttpStatusCodes.Created) {
				if (!action.isReply) {
					return updateCommentCount(state, action.clientRequestGuid, true);
				}
			}

			return state;
		}
		case types.DELETE_CLIENT_REQUESTS_COMMENT: {
			if (action.responseObj?.status === HttpStatusCodes.NoContent) {
				if (!action.isReply) {
					return updateCommentCount(state, action.clientRequestGuid, false);
				}
			}

			return state;
		}
		case types.PATCH_CLIENT_REQUEST_DUE_DATE: {
			let currentState = _.cloneDeep(state);
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				action?.meta?.data.map((item) => {
					if (item?.path) {
						const parts = item.path.split('/');
						const clientRequestId = parts.length > 1 ? parts[1] : null;
						const field = parts.length > 2 ? parts[2] : null; // DueDate
						const value = item.value;
						if (clientRequestId && !isNaN(clientRequestId) && value) {
							let requestItem = currentState.requestsReadModel.find(
								(x) => x.clientRequestID === parseInt(clientRequestId)
							);
							if (requestItem && field === 'DueDate') {
								requestItem.dueDate = moment(value).format('YYYY-MM-DD');
							}
						}
					}
				});
			}
			return {...currentState, silentRefresh: true};
		}
		case types.REASSIGN_REQUEST: {
			let currentState = _.cloneDeep(state);
			let clientRequestId = action?.meta?.clientRequestId;
			let selectedAssignment = action?.meta?.selectedAssignment;
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				var requestItem = currentState.requestsReadModel.find((id) => id.clientRequestID == clientRequestId);
				if (requestItem) {
					if (
						requestItem.clientRequestStatusID == ClientRequestStatus.InvalidClientContact ||
						requestItem.clientRequestStatusID == ClientRequestStatus.Withdrawn ||
						requestItem.clientRequestStatusID == ClientRequestStatus.NoClientContact
					) {
						requestItem.clientRequestStatusID = ClientRequestStatus.Draft;
					}

					requestItem.clientGroupName = selectedAssignment.groupName;
					requestItem.clientGroupID = selectedAssignment.groupId;
					if (selectedAssignment.isUser) {
						requestItem.firstName = selectedAssignment.firstName;
						requestItem.lastName = selectedAssignment.lastName;
						requestItem.fullName = selectedAssignment.displayName;
						requestItem.clientUserID = selectedAssignment.id;
					} else {
						requestItem.firstName = null;
						requestItem.lastName = null;
						requestItem.fullName = selectedAssignment.groupName;
						requestItem.clientUserID = null;
					}
				}
			}
			return {...currentState, silentRefresh: true};
		}
		case types.DELETE_CLIENT_REQUEST_TAG: {
			if (action.responseObj?.status === HttpStatusCodes.NoContent) {
				const readModel = state.requestsReadModel?.map((request) => {
					let filteredTags = request.tagsList.filter((tag) => tag.engagementTagID !== action.tagId);

					return {
						...request,
						tagsList: filteredTags
					};
				});

				let requests = {
					...state,
					requestsReadModel: readModel,
					silentRefresh: true
				};

				return requests;
			}

			return state;
		}
		case types.DELETE_CLIENT_REQUEST: {
			if (action?.meta?.isUpdateRequestList) {
				let currentState = _.cloneDeep(state);
				let clientRequestId = action?.meta?.clientRequestId;
				let clientRequestStatusId = action?.meta?.currentRequestStatusId;
				if (action?.responseObj?.status === HttpStatusCodes.Ok) {
					currentState.requestsReadModel = currentState.requestsReadModel.filter(
						(id) => id.clientRequestID != clientRequestId
					);

					if (currentState.countReadModel.countTotal > 0) {
						currentState.countReadModel.countTotal -= 1;
					}

					if (ParentDraft.includes(clientRequestStatusId) && currentState.countReadModel.countDraft > 0) {
						currentState.countReadModel.countDraft -= 1;
					} else if (
						ParentAccepted.includes(clientRequestStatusId) &&
						currentState.countReadModel.countAcceptedByCanvas > 0
					) {
						currentState.countReadModel.countAcceptedByCanvas -= 1;
					} else if (
						ParentReceived.includes(clientRequestStatusId) &&
						currentState.countReadModel.countReceivedByCanvas > 0
					) {
						currentState.countReadModel.countReceivedByCanvas -= 1;
					} else if (
						ParentPendingResponse.includes(clientRequestStatusId) &&
						currentState.countReadModel.countPendingResponse > 0
					) {
						currentState.countReadModel.countPendingResponse -= 1;
					}
				}
				return currentState;
			}
		}
		case types.SEND_CLIENT_REQUEST: {
			let currentState = _.cloneDeep(state);
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				let clientRequestId = action?.meta?.clientRequestId;
				let previousClientRequestId = action?.meta?.currentRequestStatusId;
				let actionType = action?.meta?.actionType;
				let quickFilter = action?.meta?.quickFilter;
				var requestItem = currentState.requestsReadModel.find((id) => id.clientRequestID == clientRequestId);
				if (requestItem) {
					requestItem.clientRequestStatusID = action?.response?.clientRequestStatusId;
					requestItem.hasErrorState = false;
				}
				if (
					quickFilter !== undefined &&
					(quickFilter != collaborationFilterTypeEnum.allrequests || actionType == ClientRequestStatus.DeleteInTransit)
				) {
					/*filtering data only when there is no 'All' filter*/
					currentState.requestsReadModel = currentState.requestsReadModel.filter(
						(id) => id.clientRequestID != clientRequestId
					);
				}
				if (actionType == ClientRequestStatus.SendInTransit) {
					currentState.countReadModel.countDraft -= 1;
					currentState.countReadModel.countPendingResponse += 1;
				} else if (actionType == ClientRequestStatus.WithdrawInTransit) {
					currentState.countReadModel.countDraft += 1;
					currentState.countReadModel.countPendingResponse -= 1;
				} else if (actionType == ClientRequestStatus.CompletionInTransit) {
					currentState.countReadModel.countReceivedByCanvas += 1;
					currentState.countReadModel.countPendingResponse -= 1;
				} else if (actionType == ClientRequestStatus.AcceptInTransit) {
					currentState.countReadModel.countAcceptedByCanvas += 1;
					currentState.countReadModel.countReceivedByCanvas -= 1;
				}
			}

			if (action?.responseObj?.status === HttpStatusCodes.InternalServerError) {
				return {...state, submitError: true};
			}
			return currentState;
		}

		case types.REFRESH_CLIENT_REQUEST_LIST: {
			if (action?.data?.updateList) {
				return {...state, updateRequestList: true};
			}
		}
		// eslint-disable-next-line no-fallthrough
		case types.PATCH_CLIENT_REQUEST_FIELDS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const newClientRequestState = _.cloneDeep(state);
				action?.meta?.data.map((item) => {
					if (item?.path) {
						const parts = item.path.split('/');
						const clientRequestId = parts.length > 1 ? parts[1] : null;
						const field = parts.length > 2 ? parts[2] : null; // RequestTitle or RequestDescription
						const value = item.value;
						if (clientRequestId && !isNaN(clientRequestId) && value) {
							let clientRequestToUpdate = newClientRequestState.requestsReadModel.find(
								(x) => x.clientRequestID === parseInt(clientRequestId)
							);
							if (clientRequestToUpdate) {
								if (field === 'RequestTitle') {
									clientRequestToUpdate.requestTitle = value;
								} else if (field === 'RequestDescription') {
									clientRequestToUpdate.requestDescription = value;
								}
							}
						}
					}
				});
				return newClientRequestState;
			}
			return state;
		}
		case types.RETURN_CLIENT_REQUEST:
			let currentState = _.cloneDeep(state);
			if (action?.responseObj?.status === HttpStatusCodes.Ok && currentState) {
				let clientRequestId = action?.meta?.clientRequestId;
				let quickFilter = action?.meta?.quickFilter;
				if (action?.meta?.previousStatusId == ClientRequestStatus.Accepted) {
					currentState.countReadModel.countAcceptedByCanvas -= 1;
				} else {
					currentState.countReadModel.countReceivedByCanvas -= 1;
				}
				currentState.countReadModel.countPendingResponse += 1;
				var requestItem = currentState.requestsReadModel.find((id) => id.clientRequestID == clientRequestId);
				if (requestItem) {
					requestItem.clientRequestStatusID = ClientRequestStatus.ReturnInTransit;
					requestItem.requestTitle = action?.meta?.updatedRequestTitle;
					requestItem.hasErrorState = false;
					if (quickFilter != collaborationFilterTypeEnum.allrequests) {
						/*filtering data only when there is no 'All' filter*/
						currentState.requestsReadModel = currentState.requestsReadModel.filter(
							(id) => id.clientRequestID != clientRequestId
						);
					}
				}
			}
			return currentState;
		case types.UPDATE_REQUEST_DETAIL_TIMEPHASE: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				let currentState = _.cloneDeep(state);
				action?.meta?.data.map((item) => {
					if (item?.path) {
						const parts = item.path.split('/');
						const clientRequestId = parts.length > 1 ? parts[1] : null;
						const field = parts.length > 2 ? parts[2] : null; // DueDate
						const value = item.value;
						if (clientRequestId && !isNaN(clientRequestId) && value) {
							let requestItem = currentState.requestsReadModel.find(
								(x) => x.clientRequestID === parseInt(clientRequestId)
							);
							if (requestItem && field === 'DueDate') {
								requestItem.dueDate = moment(value).format('YYYY-MM-DD');
							}
						}
					}
				});
				return currentState;
			}
			return state;
		}
		case types.GET_CLIENT_REQUESTS_PERSISTS_SELECTION: {
			let objectCopy = {
				...state,
				requestsReadModel: action?.response?.requestsReadModel?.map((x) => {
					let req = action?.data.requestsSelected.find((selected) => selected.clientRequestID == x.clientRequestID);
					return {...x, checked: req ? true : false};
				})
			};

			return objectCopy;
		}
		case types.PATCH_CLIENT_REQUEST_PRIORITY_TYPE: {
			let currentState = _.cloneDeep(state);
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				action?.meta?.data.map((item) => {
					if (item?.path) {
						const parts = item.path.split('/');
						const clientRequestId = parts.length > 1 ? parts[1] : null;
						const field = parts.length > 2 ? parts[2] : null; // PriorityTypeId
						const value = item.value;
						if (clientRequestId && !isNaN(clientRequestId) && value) {
							let requestItem = currentState.requestsReadModel.find(
								(x) => x.clientRequestID === parseInt(clientRequestId)
							);
							if (requestItem && field === 'PriorityTypeId') {
								requestItem.priorityTypeID = value;
							}
						}
					}
				});
			}
			return {...currentState, silentRefresh: true};
		}
		case types.UPDATE_BULK_REQUEST_TASK_RELATIONS: {
			let {bulkRequestState} = {...state};
			if (bulkRequestState) {
				bulkRequestState = {
					...bulkRequestState,
					requestsReadModel: bulkRequestState.requestsReadModel?.map((request) => {
						if (action.requests.some((r) => r.clientRequestID === request.clientRequestID)) {
							return {
								...request,
								relatedTasks: request.relatedTasks === null ? [action.task] : [...request.relatedTasks, action.task]
							};
						}
						return request;
					})
				};
				return {...state, bulkRequestState};
			}
			return state;
		}

		case types.DELETE_CLIENT_REQUEST_RELATED_TASK: {
			if (action?.responseObj?.status === HttpStatusCodes.NoContent) {
				let {bulkRequestState} = _.cloneDeep(state);
				if (bulkRequestState) {
					bulkRequestState?.requestsReadModel?.forEach((request) => {
						if (request.clientRequestID === action.meta?.clientRequestId) {
							request.relatedTasks = request.relatedTasks?.filter(
								(task) => (task.taskId || task.id) !== action.meta?.relatedTaskId
							);
						}
					});
					return {...state, bulkRequestState};
				}
			}
			return state;
		}

		case types.GET_ALL_UNRELATED_REQUESTS_COUNT: {
			if (isApiResponseOk(action)) {
				return {...state, unrelatedRequestCount: action.response.countReadModel};
			}
			return state;
		}
		case types.UPDATE_UNRELATED_REQUEST_COUNT_STORE: {
			if (_.isFinite(action.difference)) {
				const unrelatedRequestCount = {...(state.unrelatedRequestCount || {})};
				unrelatedRequestCount.countTotal += action.difference;
				return {...state, unrelatedRequestCount};
			}
			return state;
		}

		case types.SET_IS_REQUEST_LIST_UPDATE_REQUIRED: {
			return {...state, isRequestListUpdateRequired: action.isRequestListUpdateRequired};
		}
		default:
			return state;
	}
}

const updateCommentCount = (state, clientRequestGuid, increase) => {
	const readModel = state.requestsReadModel?.map((item) => {
		if (item.clientRequestGUID === clientRequestGuid) {
			return {
				...item,
				annotationCount: increase ? item.annotationCount + 1 : item.annotationCount - 1
			};
		}

		return item;
	});
	return {
		...state,
		requestsReadModel: [...readModel],
		silentRefresh: true
	};
};
